import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/common/Placeholder';
import { useTranslation } from 'react-i18next';
import { Paper } from '@mui/material';
import FinancialProductRulesEditDetailsOutputDictionariesTableHead from './FinancialProductRulesEditDetailsOutputDictionariesTableHead';
import FinancialProductRulesEditDetailsOutputDictionariesTableBody from './FinancialProductRulesEditDetailsOutputDictionariesTableBody';
import { StyledTable, StyledTableContainer } from 'components/common/Styles';

const FinancialProductRulesEditDetailsOutputDictionariesTable = ({
  canWrite,
  financialProductRuleOutputDictionaryParamList,
  outputDictionariesList,
  isSaved,
  onAdd,
  onCloseEdit,
  onDelete,
  onSave,
  financialProductRuleOutputDictionaryValidation
}) => {
  const [t] = useTranslation();
  return (
    <>
      <StyledTableContainer component={Paper}>
        <StyledTable>
          <FinancialProductRulesEditDetailsOutputDictionariesTableHead canWrite={canWrite} isSaved={isSaved} onAdd={onAdd} />
          {isSaved && (
            <FinancialProductRulesEditDetailsOutputDictionariesTableBody
              canWrite={canWrite}
              financialProductRuleOutputDictionaryParamList={financialProductRuleOutputDictionaryParamList}
              outputDictionariesList={outputDictionariesList}
              onCloseEdit={onCloseEdit}
              onDelete={onDelete}
              onSave={onSave}
              financialProductRuleOutputDictionaryValidation={financialProductRuleOutputDictionaryValidation}
            />
          )}
        </StyledTable>
      </StyledTableContainer>
      {!isSaved && <Placeholder message={t('FinancialProduct.Details.Rules.Details.PleaseCompleteGeneralData')} color={'warning'} />}
      {isSaved && outputDictionariesList?.length === 0 && <Placeholder message={t('TableIsEmpty')} color={'gray'} />}
    </>
  );
};

FinancialProductRulesEditDetailsOutputDictionariesTable.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  financialProductRuleOutputDictionaryParamList: PropTypes.array.isRequired,
  outputDictionariesList: PropTypes.object.isRequired,
  isSaved: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onCloseEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  financialProductRuleOutputDictionaryValidation: PropTypes.object.isRequired
};

export default FinancialProductRulesEditDetailsOutputDictionariesTable;
